<template>
  <div class="progress">
    <div class="progress-completed" :style="{ width: `${completed}%` }"></div>
  </div>
</template>

<script>
export default {
  name: "progress-bar",
  computed: {
    completed() {
      return this.$store.getters["interview/completed"];
    }
  }
};
</script>

<style scoped lang="scss"></style>
